// 根据生日获得年龄
export const getAge = (strAge) => {
  var birArr = strAge.split("-");
  var birYear = birArr[0];
  var birMonth = birArr[1];
  var birDay = birArr[2];

  d = new Date();
  var nowYear = d.getFullYear();
  var nowMonth = d.getMonth() + 1; //记得加1
  var nowDay = d.getDate();
  var returnAge;

  if (birArr == null) {
    return false
  };
  var d = new Date(birYear, birMonth - 1, birDay);
  if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
    if (nowYear == birYear) {
      returnAge = 0; // 
    } else {
      var ageDiff = nowYear - birYear; // 
      if (ageDiff > 0) {
        if (nowMonth == birMonth) {
          var dayDiff = nowDay - birDay; // 
          if (dayDiff < 0) {
            returnAge = ageDiff - 1;
          } else {
            returnAge = ageDiff;
          }
        } else {
          var monthDiff = nowMonth - birMonth; // 
          if (monthDiff < 0) {
            returnAge = ageDiff - 1;
          } else {
            returnAge = ageDiff;
          }
        }
      } else {
        return "--"; //返回-1 表示出生日期输入错误 晚于今天
      }
    }
    return returnAge;
  } else {
    return "--";
  }
}
// 计算工作年限
export const dateSubMonth = (date) => {
  var date1 = new Date(date);
  var date2 = new Date();
  var monthCount = parseInt(date2.getFullYear() - date1.getFullYear()) * 12 - date1.getMonth() + date2.getMonth();
  var resM = monthCount % 12;
  var resY = parseInt(monthCount / 12);
  var resStr = "";
  if (resY != 0) {
    resStr += resY + "年"
  }
  if (resM != 0) {
    resStr += resM + "月"
  }
  if (resStr == "") {
    resStr = "0";
  }
  return resStr;
}
// 根据身份证号获取个人信息
export const getUserInfoByidNumber = (idNumber) => {
  //定义籍贯、出生日期、性别、年龄等变量
  var provinces, province, birthday, currDate, month, date, age, sex;

  //一、获取籍贯，由于数据量比较大，所以这里只获取到省：
  //定义地区数组
  provinces = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
  province = provinces[parseInt(idNumber.substr(0, 2))];
  //二、出生日期
  birthday = idNumber.substring(6, 10) + "-" + idNumber.substring(10, 12) + "-" + idNumber.substring(12, 14);
  //三、计算年龄
  currDate = new Date();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  age = currDate.getFullYear() - idNumber.substring(6, 10) - 1;
  //判断年龄
  if (idNumber.substring(10, 12) < month || (idNumber.substring(10, 12) == month && idNumber.substring(12, 14) <= date)) {
    age++;
  }
  //四、获取性别
  if (parseInt(idNumber.substr(16, 1)) % 2 == 1) {
    //男
    sex = "男";
  } else {
    //女
    sex = "女";
  }
  return { province, birthday, age, sex }
}
